"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportExportDialog = void 0;
const MetaModelRegistry_1 = __importDefault(require("@opsbase/lib-data-metamodel/MetaModelRegistry"));
const cloneView_1 = __importDefault(require("@opsbase/lib-data-view/helpers/cloneView"));
const ExportFormat_1 = __importDefault(require("@opsbase/lib-general/ExportFormat"));
const getFromStringOrFunction_1 = require("@opsbase/lib-general/utils/getFromStringOrFunction");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const index_1 = require("@opsbase/lib-time/consts/index");
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useGenerateLMSSDataExport_1 = __importDefault(require("@opsbase/react-gql-hooks/lmss/useGenerateLMSSDataExport"));
const useGenerateLMSSReportPDF_1 = __importDefault(require("@opsbase/react-gql-hooks/lmss/useGenerateLMSSReportPDF"));
const react_markdown_1 = require("@opsbase/react-markdown");
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const ViewSpinner_1 = __importDefault(require("@opsbase/web-ctrl-view/ViewSpinner"));
const ConfirmDialog_1 = __importDefault(require("@opsbase/web-dialogs/ConfirmDialog"));
const Dialog_1 = __importDefault(require("@opsbase/web-dialogs/Dialog"));
const DialogSize_1 = __importDefault(require("@opsbase/web-dialogs/Dialog/DialogSize"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const useParams_1 = __importDefault(require("@opsbase/web-nav/useParams"));
const useTaskWatcherActions_1 = __importDefault(require("@opsbase/web-taskwatcher/useTaskWatcherActions"));
const TextFieldWithEmails_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithEmails/TextFieldWithEmails"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
function ReportExportDialog() {
    const { viewId, type } = (0, useParams_1.default)();
    if (type === ExportFormat_1.default.GROUP_DETAIL_PDF) {
        return (react_1.default.createElement(ViewSpinner_1.default, { viewId: viewId },
            react_1.default.createElement(ExportDialogInnerGroupDetailPDF, { viewId: viewId })));
    }
    return (react_1.default.createElement(ViewSpinner_1.default, { viewId: viewId },
        react_1.default.createElement(ExportDialogInner, { viewId: viewId, type: type })));
}
exports.ReportExportDialog = ReportExportDialog;
function ExportDialogInner({ viewId, type }) {
    const view = (0, useView_1.default)(viewId);
    const self = (0, useSelf_1.default)();
    const generateLMSSDataExport = (0, useGenerateLMSSDataExport_1.default)();
    const [isStarting, setIsStarting] = (0, react_1.useState)(false);
    const [emails, setEmails] = (0, react_1.useState)([self.email]);
    const [title, setTitle] = (0, react_1.useState)((0, getFromStringOrFunction_1.getFromStringOrFunction)(MetaModelRegistry_1.default[view.type].name) +
        ' - ' +
        (0, moment_timezone_1.default)().format(index_1.SimpleDateFormat));
    const [description, setDescription] = (0, react_1.useState)('');
    const { goBack } = (0, useNav_1.default)();
    const { watchTasks } = (0, useTaskWatcherActions_1.default)();
    const metaModel = MetaModelRegistry_1.default[view.type];
    const handleClickStart = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        setIsStarting(true);
        let task;
        const query = (0, cloneView_1.default)(view);
        view.highlightedGroups.forEach(h => {
            query.filters.push(Object.assign(Object.assign({}, h), { id: h.id }));
        });
        query.fields = query.fields.filter(f => !f.hidden);
        task = yield generateLMSSDataExport({
            email: emails.join(';'),
            title,
            description,
            format: type,
            query,
        });
        watchTasks([task]);
        goBack();
    }), [description, emails, generateLMSSDataExport, goBack, title, type, view, watchTasks]);
    if (!metaModel.canExportData)
        return null;
    return (react_1.default.createElement(Dialog_1.default, { size: DialogSize_1.default.X550_Y350, title: `${lib_i18n_1.default.t('export')} ${(0, getFromStringOrFunction_1.getFromStringOrFunction)(metaModel.name)} to ${lib_i18n_1.default.t(type)}`, buttonsRight: react_1.default.createElement(Button_1.default, { label: isStarting
                ? ''
                : `${lib_i18n_1.default.t('export')} ${(0, getFromStringOrFunction_1.getFromStringOrFunction)(metaModel.name)}`, loading: isStarting, onClick: handleClickStart }) },
        react_1.default.createElement(Text_1.default, null, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('confirm-export-data'))),
        react_1.default.createElement(TextFieldWithEmails_1.default, { value: emails, onChange: setEmails, fullWidth: true }),
        type === ExportFormat_1.default.PDF && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Text_1.default, { style: { marginTop: 16 } }, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('choose-report-title'))),
            react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { value: title, onBlur: setTitle, white: true, fullWidth: true }),
            react_1.default.createElement(Text_1.default, { style: { marginTop: 16 } }, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('choose-report-description'))),
            react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { value: description, onBlur: setDescription, white: true, fullWidth: true })))));
}
function ExportDialogInnerGroupDetailPDF({ viewId }) {
    const view = (0, useView_1.default)(viewId);
    const self = (0, useSelf_1.default)();
    const generateLMSSReportPDF = (0, useGenerateLMSSReportPDF_1.default)();
    const { goBack } = (0, useNav_1.default)();
    const { watchTasks } = (0, useTaskWatcherActions_1.default)();
    const metaModel = MetaModelRegistry_1.default[view.type];
    const handleConfirm = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        const query = (0, cloneView_1.default)(view);
        // eslint-disable-next-line sonarjs/no-identical-functions
        view.highlightedGroups.forEach(h => {
            query.filters.push(Object.assign(Object.assign({}, h), { id: h.id }));
        });
        query.fields = query.fields.filter(f => !f.hidden);
        const task = yield generateLMSSReportPDF({
            format: ExportFormat_1.default.GROUP_DETAIL_PDF,
            email: self.email,
            query,
        });
        watchTasks([task]);
        goBack();
    }), [generateLMSSReportPDF, goBack, self.email, view, watchTasks]);
    if (!metaModel.canExportData)
        return null;
    return (react_1.default.createElement(ConfirmDialog_1.default, { size: DialogSize_1.default.X400_Y250, onConfirm: handleConfirm, disableGoBackOnConfirm: true },
        react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('produce-print-friendly'))));
}
exports.default = ReportExportDialog;
